import ApiBase from '@/api/base';

export default {
  signinUser (args) {
    return ApiBase.post(`/user/signin`, args);
  },
  signoutUser () {
    return ApiBase.post('/user/signout');
  },
};
